import {FormSectionType} from '../../../../../../blocks/FormBlock'
import box from '../../fields/box'
import city from '../../fields/city'
import companyName from '../../fields/copmanyName'
import companyVat from '../../fields/companyVat'
import confirmEMail from '../../fields/confirmEMail'
import defaultInvoiceData from '../personal/invoiceData'
import email from '../../fields/eMail'
import houseNumber from '../../fields/houseNumber'
import orderNumber from '../../fields/orderNumber'
import sameAsClientPersonalData from '../../fields/sameAsClientPersonalData'
import street from '../../fields/street'
import zip from '../../fields/zip'
import {copy} from '../../../../../../../util/fieldscopy'

const invoiceData: FormSectionType = {
	...defaultInvoiceData,
	fields: [
		{...companyName, label: 'Naam vzw'},
		companyVat,
		orderNumber,
		{...email, label: copy?.invoice || 'Facturatie e-mailadres'},
		{
			...confirmEMail,
			label: copy?.confirm_invoice || 'Herhaal facturatie e-mailadres'
		},
		sameAsClientPersonalData,
		street,
		houseNumber,
		box,
		zip,
		city
	].map((field) => {
		return {...field, parent_id: 2}
	})
}

export default invoiceData
